import { render, staticRenderFns } from "./MultiButton.vue?vue&type=template&id=07fb07e6&scoped=true&"
import script from "./MultiButton.vue?vue&type=script&lang=ts&"
export * from "./MultiButton.vue?vue&type=script&lang=ts&"
import style0 from "./MultiButton.vue?vue&type=style&index=0&id=07fb07e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07fb07e6",
  null
  
)

export default component.exports